import React, { FC } from 'react';

import BTB from '../Member/components/BTB';
import LogoButton from '../Member/components/naviagation/LogoButton';
import { Z_INDEX } from '../utils/common/zIndex';

const FixedBTB: FC<{
  marginTop?: number;
  marginBottom?: number;
  middleComponent?: React.ReactNode;
  children: React.ReactNode;
  visibility?: 'invisible' | 'visible';
}> = ({
  children,
  marginTop = 10,
  marginBottom = 10,
  middleComponent = (
    <div className="absolute-center flex-center">
      <LogoButton />
    </div>
  ),
  visibility = 'invisible',
}) => {
  return (
    <div
      className={`fixed inset-x-0 top-0 bg-white ${visibility}`}
      style={{ zIndex: Z_INDEX.FIXED_BTB }}
    >
      <BTB
        middleComponent={middleComponent}
        rightComponent={children}
        marginTop={marginTop}
        marginBottom={marginBottom}
        style={{ padding: '0px 16px 0px 16px' }}
        btbHeight={56}
      />
    </div>
  );
};

export default FixedBTB;
